<div>
  <input id="job_file_input_candidate" #myFileInputcandidate style="display: none;" type="text"
    (click)="myFileInputcandidate.value=null" (change)="fileChangeEvent('')" />
  <div *ngIf="passValues?.length > 0; else noResult">
    <div *ngFor="let items of passValues; let lastItem = last; let index = i">
      <ng-container *ngIf="viewSize === 'large'">
        <div class="hpanel">
          <div id="jobBody" class="panel-body pad-cus hover-border border-radius-top-left-right-6" [ngClass]="{
                          'disabled': !items?.availability || (items?.status != 'ACTIVE' && items?.jobPostedBy != userId),
                          'pad-10': viewSize == 'small',
                          'featured-background': items?.isFeatured==true,
                          'UpdatedJobHighLight' : jobIdHighLight==items?.jobId,
                          'Business_background': items.transferJob }">


            <ng-container>
              <div class="col-sm-4" [ngClass]="{'business-jobs': CheckboxforBusinessJobs}"
                id="job_stopPropagation_container" (click)="$event.stopPropagation();">

                <div class="col-sm-1" *ngIf="CheckboxforBusinessJobs">
                  <input id="job_business_checkbox_{{index}}" type="checkbox"
                    (click)="BusinessJobChecked($event.target.checked , items , index)" [(ngModel)]="items.transferJob"
                    aria-label="Select" />
                </div>

                <div class="gs-job-poster" [ngClass]="{'flxxy1': applyingJob}">
                  <div class="gs-job-poster__avatar">
                    <img *ngIf="items?.user?.photo && !items?.user?.photo.includes('userAvatar')"
                      class="gs-job-poster__photo" [src]="items?.user?.photo" alt="">
                    <div class="gs-job-poster__initials"
                      *ngIf="!items?.user?.photo || items?.user?.photo.includes('userAvatar')"
                      [style.background-color]="getColor(items?.user?.fullname)"
                      [style.color]="getFullNameTextColor(items?.user?.fullname)">
                      {{ getInitials(items?.user?.fullname) }}
                    </div>

                    <ng-container *ngIf="items?.user?.userType!='FREELANCE_RECRUITER' && items?.user?.userType!='student' && items?.user?.userType!='JOB_SEEKER'">
                      <span class="gs-job-poster__badge" title="Vendor"
                        *ngIf="items?.user?.workExperience[0]?.clientType=='Vendor'">V</span>
                      <span class="gs-job-poster__badge" title="Direct Hire"
                        *ngIf="items?.user?.workExperience[0]?.clientType==GigsumoConstant.DIRECT_HIRE">DH</span>
                      <span class="gs-job-poster__badge" title="Systems Integrator"
                        *ngIf="items?.user?.workExperience[0]?.clientType=='Systems Integrator'">SI</span>
                      <span class="gs-job-poster__badge" title="Prime Vendor"
                        *ngIf="items?.user?.workExperience[0]?.clientType=='Prime Vendor'">PV</span>
                      <span class="gs-job-poster__badge" title="Recruitment Process Outsourcer"
                        *ngIf="items?.user?.workExperience[0]?.clientType=='Recruitment Process Outsourcer'">RPO</span>
                      <span class="gs-job-poster__badge" title="Staffing Agency"
                        *ngIf="items?.user?.workExperience[0]?.clientType=='Staffing Agency'">SA</span>
                      <span class="gs-job-poster__badge" title="Client"
                        *ngIf="items?.user?.workExperience[0]?.clientType=='Client'">C</span>
                      <span class="gs-job-poster__badge" title="Direct Client"
                        *ngIf="items?.user?.workExperience[0]?.clientType=='Direct Client'">DC</span>
                    </ng-container>
                    <span class="gs-job-poster__badge" title="Supplier"
                      *ngIf="items?.user?.workExperience[0]?.clientType=='Supplier'">SP</span>
                    <span class="gs-job-poster__badge" title="Freelance Recruiter"
                      *ngIf="items?.user?.userType=='FREELANCE_RECRUITER'">FR</span>
                  </div>

                  <div class="gs-job-poster__info" id="job_media_body_container"
                    (click)="$event.stopPropagation();">
                    <div class="gs-job-poster__name-row" id="job_user_card_container"
                      (click)="$event.stopPropagation();">
                      <div class="custom-checkbox"
                        *ngIf="items?.inviteStatus==undefined && items?.currentStatus == undefined && applyingJob"
                        title="Select Job">
                        <input id="job_select_checkbox" class="check-btn-ui check-ui" #selected
                          (change)="selectCheckbox(items?.jobId,selected)" type="checkbox" value="{{items.isSelected}}"
                          [(ngModel)]="items.isSelected" name="list_name" />
                      </div>
                      <h6 class="gs-job-poster__name" title="{{items?.user?.fullname}}">{{items?.user?.fullname}}</h6>
                    </div>
                    <div class="gs-job-poster__org" *ngIf="items?.jobPostedBehalfOf != 'null'"
                      title="{{items?.jobPostedBehalfOf}}">
                      {{items?.jobPostedBehalfOf}}
                    </div>
                    <small class="gs-job-poster__date">{{ items?.updatedOn | timezoneDate: 'MM/dd/yyyy' }}</small>
                  </div>
                </div>

              </div>
              <div class="col-md-8 cardListItm">
                <div class="row">
                  <div class=" flex pull-right actItemList">
                    <div> <button style="color:#fff;"
                        *ngIf="applyingJob && items?.inviteStatus!=null||applyingJob &&items?.currentStatus!=null; else statusShow"
                        type="button" class="btn  status-action-btn dwidth" [ngStyle]="{'background': (items?.currentStatus === 'SELECTED') ?'#3CB371' :
                                 (items?.currentStatus === 'REJECTED' ) ?'#fe4052' :
                                 (items?.currentStatus === 'ONBOARDED') ? '#17a2b8' :
                                 (items?.currentStatus === 'INTERVIEW SCHEDULED') ? '#3498db' :
                                 (items?.currentStatus === 'REJECT') ? '#3498db' :
                                 (items?.currentStatus === 'SHORTLISTED'||!applyingJob) ? '#3498db' :
                                 (items?.currentStatus === 'PREONBOARDED') ? '#3498db' :
                                 (items?.currentStatus === 'OFFER WITHDRAWN') ? '#fe4052' :
                                 (items?.inviteStatus === 'ACCEPTED') ? '#008000' :
                                 (items?.inviteStatus === 'REJECTED') ? '#fe4052' :
                                 (items?.currentStatus === 'APPLIED') ? '#008000' :
                                 (items?.inviteStatus === 'INITIATED') ? '#8B5CF6' :
                                 (items?.currentStatus === 'INTETEREST_SHOWN') ? '#8B5CF6' :
                                 (items?.currentStatus === 'CANDIDATE BACKOUT') ? '#fe4052' :
                                 (items?.currentStatus === 'OFFERED') ? '#fe4052': ''}">
                        <ng-container *ngIf="items?.inviteStatus == 'INITIATED'"> Invited </ng-container>
                        <ng-container *ngIf="items?.inviteStatus === 'INTETEREST_SHOWN'"> Invited </ng-container>
                        <ng-container *ngIf="items?.inviteStatus === 'REJECTED'"> Rejected </ng-container>
                        <ng-container *ngIf="items?.inviteStatus != 'INITIATED'">
                          {{items?.currentStatus|titlecase}}</ng-container>
                      </button>
                      <div id="jb_dpDown" [ngClass]="{'disabled':items?.status=='BLOCKED'}" class="btn-group" dropdown
                        *ngIf="items?.jobPostedBy==userId ">
                        <button
                          *ngIf="items?.status!='DRAFTED'&& items?.status!='AWAITING HOST'&& items?.status!='BLOCKED' && items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& applyingJob==false "
                          data-toggle="dropdown" dropdownToggle class="br-pd-1" aria-expanded="true" [ngClass]="{'active-label br-pd-1': (items?.status === 'ACTIVE' && items?.jobPostedBy==userId),
                          'active-non-owner-label': (items?.status === 'ACTIVE' && items?.jobPostedBy!=userId),
                          'inactive-label':(items?.status === 'INACTIVE'),
                          'onhold-label':(items?.status === 'ON HOLD'),
                          'filled-label':(items?.status === 'FILLED'),
                          'deactivated-label':(items?.status === 'DEACTIVATED'),
                          'awaiting-label':(items?.status === 'AWAITING HOST'),
                          'low-credit-label':(items?.status === 'INACTIVE_DUE_TO_LOW_CREDITS')}">
                          {{items?.status|titlecase}} <ng-icon name="tablerChevronDown" aria-hidden="true"></ng-icon>
                        </button>
                        <button *ngIf="items?.status=='BLOCKED'&& applyingJob==false" data-toggle="dropdown"
                          dropdownToggle class="btn sm-listing-btn dropdown-toggle" aria-expanded="true">Active
                          <ng-icon name="tablerChevronDown" aria-hidden="true"></ng-icon></button>
                        <ng-container
                          *ngIf="items?.status!='DRAFTED' &&  items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& items?.status!='DEACTIVATED' && items?.status!='BLOCKED'&&items?.status!='FILLED'&&items?.status!='AWAITING HOST'">
                          <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right job-status-menu" role="menu"
                            style="right: 0;" aria-labelledby="button-animated">
                            <li id="job_status_active_large_menu" role="menuitem" *ngIf="items?.status!='ACTIVE'"
                              (click)="enableJob('ACTIVE',items)">
                              <a id="ACTIVE"><ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>Active </a>
                            </li>
                            <!-- <li role="menuitem" *ngIf="items?.status!='INACTIVE'  " (click)="enableJob('INACTIVE',items)"
                              id="INACTIVE">
                              <a id="INACTIVE"><ng-icon name="tablerCircle" class="fs-status-icon t-inActive" aria-hidden="true"></ng-icon>&nbsp;Inactive </a>
                            </li> -->
                            <li id="job_status_onhold_large_menu" role="menuitem" *ngIf="items?.status!='ON HOLD' "
                              (click)="enableJob('ON HOLD',items)">
                              <a id="ON HOLD"><ng-icon name="tablerCircle" class="fs-status-icon t-hold" aria-hidden="true"></ng-icon>On Hold </a>
                            </li>
                            <li id="job_status_filled_menu" role="menuitem" *ngIf="items?.status!='FILLED'"
                              (click)="enableJob('FILLED',items)">
                              <a id="FILLED"><ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>Filled </a>
                            </li>
                            <!-- <li role="menuitem" *ngIf="items?.status!='CLOSED' " (click)="enableJob('CLOSED',items)"
                              id="CLOSED">
                              <a id="CLOSED"> <ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon>&nbsp;Closed </a>
                            </li>
                            <li class="disabled" role="menuitem" id="Deactivated">
                              <a id="Deactivated"> <ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon>
                                Deactivated </a>
                            </li> -->
                          </ul>
                        </ng-container>
                      </div>
                      <div id="jb_dpDown" class="btn-group" dropdown *ngIf="items?.jobPostedBy!=userId "> <button
                          *ngIf="items?.status!='DRAFTED' && items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& applyingJob==false && items?.status=='ACTIVE'"
                          data-toggle="dropdown" dropdownToggle class="br-pd-1" aria-expanded="true"
                          [ngClass]="{'active-label': (items?.status === 'ACTIVE' && items?.jobPostedBy==userId),
                          'active-non-owner-label': (items?.status === 'ACTIVE' && items?.jobPostedBy!=userId),
                                                                  'inactive-label':(items?.status === 'INACTIVE'),
                                                                  'onhold-label':(items?.status === 'ON HOLD'),
                                                                  'filled-label':(items?.status === 'FILLED'),
                                                                  'deactivated-label':(items?.status === 'DEACTIVATED'),
                                                                  'awaiting-label':(items?.status === 'AWAITING HOST'),
                                                                  'low-credit-label':(items?.status === 'INACTIVE_DUE_TO_LOW_CREDITS')}">
                          {{items?.status|titlecase}}
                        </button>
                      </div>
                      <ng-template #statusShow>
                        <button *ngIf="applyingJob && items?.inviteStatus==null&& items?.currentStatus!='APPLIED'"
                          type="button" class="btn btn-primary status-action-btn dwidth">Active</button>
                        <button *ngIf="items?.status=='DRAFTED'" type="button"
                          class="btn draft-status-btn status-action-btn dwidth">Draft</button>
                      </ng-template>
                    </div>
                    <div [ngClass]="{'disabled':items?.status=='BLOCKED'}" class="btn-group"
                      *ngIf="items?.jobPostedBy==userId && !applyingJob &&items?.status!='FILLED'" dropdown>
                      <a id="button-animated" dropdownToggle id="jobThreeDot">
                        <ng-icon name="tablerDotsVertical" class="actionIconDot"></ng-icon>
                      </a>
                      <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                        style="right: 0; left: auto; z-index: 2;margin-top:15px;" aria-labelledby="button-animated">
                        <!-- <li role="menuitem">
                                    <a (click)="open(items)">
                                      <ng-icon name="tablerEye" aria-hidden="true"></ng-icon> View
                                    </a>
                                  </li> -->
                        <li role="menuitem" *ngIf=" items?.jobPostedBy==userId ">
                          <a id="job_edit_action_large" (click)="editJob(items)">
                            <ng-icon name="tablerEdit" aria-hidden="true"></ng-icon> Edit
                          </a>
                        </li>
                        <li id="job_upgrade_action_large" (click)="featurejobvalues(items)" role="menuitem"
                          *ngIf=" items?.jobPostedBy==userId && items?.status!='INACTIVE'&& items?.status!='DRAFTED'  &&items?.status!='ON HOLD'&&items?.status!='FILLED'&& items?.isFeature=='null'  && userType !='JOB_SEEKER'  ||   !items?.isFeatured  && items?.status!='INACTIVE' && items?.status!='DRAFTED' &&items?.status!='ON HOLD'&&items?.status!='FILLED' && items?.jobPostedBy==userId && userType !='JOB_SEEKER' ">
                          <a>
                            <ng-icon name="tablerCircleArrowUp" aria-hidden="true"></ng-icon> Upgrade Job
                          </a>
                        </li>
                        <li id="job_downgrade_action_large" (click)="downgradeJob(items)" role="menuitem"
                          *ngIf=" items?.jobPostedBy==userId && items?.isFeatured && items?.status!='INACTIVE'  && items?.status!='DRAFTED'">
                          <a><ng-icon name="tablerCircleArrowDown" aria-hidden="true"></ng-icon> Downgrade job</a>
                        </li>
                        <li id="job_republish_action_large" (click)="republishJob(items)" role="menuitem"
                          *ngIf="items?.jobPostedBy==userId && items?.status=='ACTIVE'">
                          <a><ng-icon name="tablerRefresh" aria-hidden="true"></ng-icon> Republish</a>
                        </li>
                        <li id="job_discard_draft_large" (click)="deletedraft(items?.jobId)" role="menuitem"
                          *ngIf=" items?.jobPostedBy==userId  && items?.status=='DRAFTED'">
                          <a><ng-icon name="tablerTrash" aria-hidden="true"></ng-icon> Discard</a>
                        </li>
                      </ul>
                    </div>
                    <!-- Non-owner kebab. Report Job is the ONLY thing this menu can
                         ever contain - the Upgrade Job item below requires
                         jobPostedBy==userId, which can never be true inside this
                         jobPostedBy!=userId wrapper - so with reportEnabled off the
                         button would open an empty dropdown. Gated on the same flag
                         so the whole control disappears and comes back together. -->
                    <div class="btn-group pull-right" *ngIf="reportEnabled && items?.jobPostedBy!=userId && !applyingJob" dropdown>
                      <a id="button-animated" dropdownToggle>
                        <ng-icon name="tablerDotsVertical" class="actionIconDot"></ng-icon>
                      </a>
                      <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                        style="right: 0; left: auto; z-index: 2;" aria-labelledby="button-animated">
                        <li role="menuitem" class="report" *ngIf="reportEnabled"
                          style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                          <app-flag type="JOB" [id]="items?.jobId" [flagTo]="items?.jobPostedBy"
                            [flags]="['Report Job as fake.']">
                          </app-flag>
                        </li>
                        <!-- <li role="menuitem">
                                    <a (click)="open(items)">
                                      View
                                    </a>
                                  </li> -->
                        <li id="job_upgrade_non_owner_large" (click)="featurejobvalues(items)" role="menuitem"
                          *ngIf=" items?.jobPostedBy==userId && items?.isFeature=='null'  &&  userType !='student' && userType !='JOB_SEEKER'  ||   !items?.isFeatured && items?.jobPostedBy==userId &&  userType !='student' && userType !='JOB_SEEKER' ">
                          <a>
                            Upgrade Job
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h6 id="job_title" class="fw-bold" (click)="open(items);routeBusiness(items)" *ngIf="!flag" [title]="items?.jobTitle">
                    {{items?.jobTitle}}
                  </h6>
                  <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(items) as urgencyDays">
                    <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Urgent Hire</span>
                    <span class="urgent-hire-countdown">Urgency ends in {{urgencyDays}} day{{urgencyDays === 1 ? '' : 's'}}</span>
                  </div>
                  <div id="job_details_container_large" (click)="open(items);routeBusiness(items)">
                    <!-- Experience on its own block row so the skills always sit on a
                         dedicated row beneath it (previously the inline span + inline-block
                         skills shared a line and only wrapped when out of width). -->
                    <div *ngIf="!flag">
                      <span>
                        Experience : {{ items?.experienceFrom}} to {{items?.experienceTo }}
                        Years
                      </span>
                    </div>
                    <!-- skills -->
                    <div class="btn-group jobProfileBtngp text-wrapsfilter" style="margin-left: 0px; margin-top: 4px; display: flex; width: 100%;"
                      id="job_skills_container_large" (click)="open(items)">
                      <!-- Club primary + secondary skills into one list (getAllSkills),
                           then render up to 3 chips (+N) exactly as before. Previously
                           only primarySkills was used, and only for counts 1/2/3. -->
                      <ng-container *ngIf="getAllSkills(items) as skills">
                        <div style="display: flex; column-gap: 0.5rem;" *ngIf="skills.length==1">
                          <div *ngFor="let data of skills; let i = index;">
                            <div title="{{data}}" class="ioxlp-1-ele">
                              {{data}}
                            </div>
                          </div>
                        </div>
                        <div style="display: flex; column-gap: 0.5rem;" *ngIf="skills.length==2">
                          <div *ngFor="let data of skills; let i = index;">
                            <div title="{{data}}" class="ioxlp-2-ele">
                              {{data}}
                            </div>
                          </div>
                        </div>
                        <div style="display: flex; column-gap: 0.5rem;" *ngIf="skills.length==3">
                          <div *ngFor="let data of skills; let i = index;">
                            <div title="{{data}}" class="ioxlp-3-ele">
                              {{data}}
                            </div>
                          </div>
                        </div>
                        <!-- 4+ skills: the count-specific blocks above only cover 1/2/3,
                             so jobs with 4 or more skills rendered NOTHING.
                             Show the first 3 (same look as the ==3 case) plus a +N chip. -->
                        <div style="display: flex; column-gap: 0.5rem;" *ngIf="skills.length>=4">
                          <div *ngFor="let data of skills | slice:0:3; let i = index;">
                            <div title="{{data}}" class="ioxlp-3-ele">
                              {{data}}
                            </div>
                          </div>
                          <div class="ioxlp-3-ele" title="{{ skills.slice(3).join(', ') }}">
                            +{{ skills.length - 3 }}
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div id="job_client_details_large" style="display: flex; flex-direction: column; width: 100%;"
                    (click)="open(items)">
                    <div class="row clientDetailList" *ngIf="!flag"
                      title=" {{items?.clientType}}, {{items?.city}}, {{items?.state}} ">
                      <div class="mb-5" title="{{items?.clientName}}" *ngIf="items?.showClientName">
                        <!-- <ng-icon name="tablerBuilding"></ng-icon> -->
                        <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                        {{items?.clientName | truncate:20}}
                      </div>
                      <div class="mb-5" title="{{items?.clientType}}" *ngIf="items?.showClientType">
                        <ng-icon name="tablerBriefcase" title="{{items?.clientType}}" class="svg-position"></ng-icon>
                        <!-- <ng-icon name="tablerBriefcase"></ng-icon> -->
                        {{items?.clientType}}
                      </div>
                      <div class="mb-5" title="{{items?.city}} , {{items?.state}}">
                        <!-- <ng-icon name="tablerMapPin" *ngIf="items?.city || items?.state"></ng-icon> -->
                        <ng-icon name="tablerMapPin" *ngIf="items?.city || items?.state" class="svg-position"></ng-icon>

                        {{items?.city}}
                        <span *ngIf="items?.state">,</span> {{items?.state}}
                      </div>
                      <div title="{{items?.jobClassification}}" class="mb-5">
                        <ng-icon name="tablerBriefcase" title="{{items?.jobClassification}}" class="svg-position"></ng-icon>
                        <!-- <ng-icon name="tablerBriefcase" title="{{items?.jobClassification}}"></ng-icon> -->
                        {{items?.jobClassification}}
                      </div>
                      <div class="mb-5" [title]="(items?.targetRateFrom && items?.targetRateTo) ?
                                        ('Employer Estimate: ' + items?.targetRateFrom + ' - ' + items?.targetRateTo + ' ' + getJobCurrency(items) + ' / ' + getPayType(items?.payType)) :
                                        'Employer Estimate: Not available'" class="job-pay">
                        Employer Estimate:
                        <ng-container *ngIf="items?.targetRateFrom && items?.targetRateTo; else noRateV2Large">
                          <span>{{items?.targetRateFrom}} - {{items?.targetRateTo}}</span>
                          <span>{{getJobCurrency(items)}} / {{getPayType(items?.payType)}}</span>
                        </ng-container>
                        <ng-template #noRateV2Large><span>Not available</span></ng-template>
                      </div>

                      <div title="Remote" *ngIf="items?.workMode=='Remote'" class="mb-5">
                        <!-- <ng-icon name="tablerMapPin"></ng-icon> -->
                        <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                        Remote
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-sm-12">
                <div class="interactive-elements row actItemLk"
                  [ngClass]="{'disabled': applyingJob==true||items?.status=='BLOCKED'}">
                  <div id="job_views_non_owner_large" *ngIf="items?.jobPostedBy!=userId && items?.viewedByCount > 0"
                    title="{{items?.viewedByCount}} Views" style="cursor: context-menu;" (click)="goTo(items, 'views')">
                    <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span class="blue-color">
                      {{ items?.viewedByCount | compactCount }}</span> Views
                  </div>
                  <div id="job_no_views_non_owner_large" *ngIf="items?.jobPostedBy!=userId && items?.viewedByCount == 0"
                    (click)="goTo(items, 'noviews')" title="0 Views" style="cursor: context-menu;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                    <span class="blue-color">
                      0</span> Views
                  </div>
                  <div id="job_views_owner_large" (click)="goTo(items, 'views')"
                    *ngIf="items?.jobPostedBy==userId && items?.viewedByCount > 0"
                    title="{{items?.viewedByCount}} Views" style="cursor: pointer;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span class="blue-color">
                      {{ items?.viewedByCount | compactCount }}</span> Views
                  </div>
                  <div id="job_no_views_owner_large" *ngIf="items?.jobPostedBy==userId && items?.viewedByCount == 0"
                    (click)="goTo(items, 'noviews')" title="0 Views"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                    <span class="blue-color">
                      0</span> Views
                  </div>
                  <div id="job_like_button" [ngClass]="{'disabled': items?.status!='ACTIVE'}" title="Like"
                    (click)="like(items)" *ngIf="items?.isLiked!=null && !items?.isLiked">
                    <ng-icon name="tablerHeart" class="pointer icon-prime-color"></ng-icon>
                  </div>
                  <div id="job_unlike_button" (click)="like(items)" [ngClass]="{'disabled': items?.status!='ACTIVE'}"
                    title="Unlike" *ngIf="items?.isLiked!=null &&  items?.isLiked">
                    <ng-icon name="tablerHeart" class="liked pointer bg-heart"></ng-icon>
                  </div>
                  <div id="job_likes_owner_large" (click)="goTo(items, 'jobs-liked')"
                    title="{{items?.likesCount}} Likes" *ngIf="items?.jobPostedBy==userId">
                    <span class="blue-color" *ngIf="items?.likesCount>0">{{ items?.likesCount | compactCount }}</span>
                    <span id="job_likes_text_large" (click)="goTo(items, 'jobs-liked')" *ngIf="items?.likesCount>0">
                      Like<span *ngIf="items?.likesCount>1">s
                      </span> </span>
                    <div title="0 Likes" class="no-views" *ngIf="items?.jobPostedBy==userId && items?.likesCount == 0"
                      style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like
                    </div>
                  </div>
                  <div title="{{items?.likesCount}} Likes" *ngIf="items?.jobPostedBy!=userId"
                    style="cursor: context-menu!important;">
                    <span class="blue-color" *ngIf="items?.likesCount>0">{{ items?.likesCount | compactCount }}</span>
                    <span *ngIf="items?.likesCount>0"> Like<span *ngIf="items?.likesCount>1">s </span> </span>
                    <div title="0 Likes" class="no-views" *ngIf="items?.jobPostedBy!=userId && items?.likesCount == 0"
                      style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like
                    </div>
                  </div>
                  <div id="job_applied_owner_large" (click)="goTo(items,'jobs-applied')"
                    *ngIf="items?.jobPostedBy==userId">
                    <ng-icon name="tablerUsers" class="pointer icon-prime-color" style="padding-right: 4px;"></ng-icon>
                    <span title="{{items?.appliedCount}} Applied" class="blue-color"
                      *ngIf="items?.appliedCount>0">{{ items?.appliedCount | compactCount }}</span>
                    <span title="0 Applied" class="blue-color" *ngIf="items?.appliedCount==0"> 0</span>
                    Applied
                  </div>
                  <div id="job_applied_non_owner_large" (click)="goTo(items,'candidate-applied')"
                    *ngIf="items?.jobPostedBy!=userId">
                    <ng-icon name="tablerUsers" class="pointer icon-prime-color" style="padding-right: 4px;"></ng-icon>
                    <span title="{{items?.candidatesApplied?.length}} Applied" class="blue-color"
                      *ngIf="items?.candidatesApplied?.length>0">{{items?.candidatesApplied?.length}}</span>
                    <span title="0 Applied" class="blue-color"
                      *ngIf="items?.candidatesApplied?.length===0 ||items?.candidatesApplied==null"> 0 </span>
                    Applied
                  </div>
                  <div id="job_invites_large" title="Invites Received Count" (click)="goTo(items,'candidates-invited')"
                    *ngIf="items?.jobPostedBy==userId">
                    <ng-icon name="tablerUsers" class="pointer icon-prime-color" style="padding-right: 4px;"></ng-icon>
                    <span title="{{items?.interestShownCount}} Invites" class="blue-color"
                      *ngIf="items?.interestShownCount>0">{{ items?.interestShownCount | compactCount }}</span>
                    <span title="0 Invites" class="blue-color" *ngIf="items?.interestShownCount==0"> 0</span>
                    Invites
                  </div>
                  <div id="job_apply_button" title="Apply" [ngClass]="{'disabled': items?.status!='ACTIVE'}"
                    *ngIf=" items?.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER' || userType == 'student' || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
                    (click)="apply(items, connectionTemplate, candidateSupplyTemplate)">
                    <ng-icon name="tablerLink" class="icon-prime-color"></ng-icon> Apply
                  </div>
                  <div id="job_chat_with_messages_large" *ngIf=" items?.chatHistoryCount > 0"
                    title="{{items?.nonSeenMessageCount > 0 ? items?.nonSeenMessageCount + ' Messages' : 'No Messages'}}" style="cursor: context-menu;"                    (click)="openMessagecheckInteraction(items, connectionTemplate)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                    <span class="blue-color" *ngIf="items?.nonSeenMessageCount>0">{{items?.nonSeenMessageCount}}</span>
                    Chat
                  </div>
                  <div id="job_chat_no_messages_non_owner_large"
                    *ngIf="items?.jobPostedBy!=userId && items?.chatHistoryCount == 0"
                    (click)="openMessagecheckInteraction(items, connectionTemplate)" title="No Messages"
                    style="cursor: context-menu;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                    Chat
                  </div>
                  <div id="job_chat_no_messages_owner_large"
                    *ngIf="items?.jobPostedBy==userId && items?.chatHistoryCount == 0" title="No Messages"
                    style="cursor: context-menu;"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                    Chat
                  </div>
                </div>
              </div>
            </ng-container>
            <app-common-skeleton *ngIf="viewSize === 'small' && loadAPIcall" [countforView]="2"
              [NameOftheScreen]="'jobcardMediumscreen'">
            </app-common-skeleton>
          </div>
        </div>
      </ng-container>
      <!-- viewSize 'business-row': business Jobs page (wireframe gigsumo-inapp-company-page-Opti.html
           #panel-jobs .job-row). Everything from 'large' above, same bindings and conditions,
           laid out as a 3-line row. Styled only by .bjr-* in job.component.scss. -->
      <ng-container *ngIf="viewSize === 'business-row'">
        <div class="bjr-row" [ngClass]="{
              'bjr-row--disabled': !items?.availability || (items?.status != 'ACTIVE' && items?.jobPostedBy != userId),
              'bjr-row--featured': items?.isFeatured==true,
              'bjr-row--highlight': jobIdHighLight==items?.jobId,
              'bjr-row--transfer': items.transferJob,
              'bjr-row--last': lastItem }">

          <!-- Line 1: title + meta · status · actions -->
          <div class="bjr-line1">
            <div class="bjr-select" *ngIf="CheckboxforBusinessJobs" (click)="$event.stopPropagation();">
              <input id="job_business_checkbox_bizrow_{{index}}" type="checkbox"
                (click)="BusinessJobChecked($event.target.checked , items , index)" [(ngModel)]="items.transferJob"
                aria-label="Select" />
            </div>
            <div class="bjr-select" *ngIf="items?.inviteStatus==undefined && items?.currentStatus == undefined && applyingJob"
              title="Select Job" (click)="$event.stopPropagation();">
              <input id="job_select_checkbox_bizrow" class="check-btn-ui check-ui" #bjrSelected
                (change)="selectCheckbox(items?.jobId,bjrSelected)" type="checkbox" value="{{items.isSelected}}"
                [(ngModel)]="items.isSelected" name="list_name" />
            </div>

            <div class="bjr-info">
              <div class="bjr-title-row">
                <a id="job_title_bizrow" class="bjr-title" *ngIf="!flag" [title]="items?.jobTitle"
                  (click)="open(items);routeBusiness(items)">{{items?.jobTitle}}</a>
                <span class="bjr-featured" *ngIf="items?.isFeatured==true">Featured</span>
              </div>
              <!-- Wireframe meta: classification · Remote (or city, state) · rate. Client type /
                   name stay in the tooltip, as in the large card's client-details title. -->
              <div id="job_client_details_bizrow" class="bjr-meta" (click)="open(items)"
                title=" {{items?.clientType}}, {{items?.city}}, {{items?.state}} ">
                <span *ngIf="items?.jobClassification" title="{{items?.jobClassification}}">{{items?.jobClassification}}</span>
                <span *ngIf="!flag && items?.workMode=='Remote'" title="Remote">Remote</span>
                <span *ngIf="!flag && items?.workMode!='Remote' && (items?.city || items?.state)" title="{{items?.city}} , {{items?.state}}">{{items?.city}}<ng-container *ngIf="items?.city && items?.state">, </ng-container>{{items?.state}}</span>
                <span *ngIf="!flag && items?.targetRateFrom && items?.targetRateTo"
                  [title]="'Employer Estimate: ' + items?.targetRateFrom + ' - ' + items?.targetRateTo + ' ' + getJobCurrency(items) + ' / ' + getPayType(items?.payType)">{{items?.targetRateFrom}} - {{items?.targetRateTo}} {{getJobCurrency(items)}} / {{getPayType(items?.payType)}}</span>
              </div>
            </div>

            <!-- Status: same branches as 'large' -->
            <div class="bjr-status">
              <span *ngIf="applyingJob && items?.inviteStatus!=null||applyingJob &&items?.currentStatus!=null; else bjrStatusShow"
                class="bjr-pill bjr-pill--solid" [ngStyle]="{'background': (items?.currentStatus === 'SELECTED') ?'#3CB371' :
                         (items?.currentStatus === 'REJECTED' ) ?'#fe4052' :
                         (items?.currentStatus === 'ONBOARDED') ? '#17a2b8' :
                         (items?.currentStatus === 'INTERVIEW SCHEDULED') ? '#3498db' :
                         (items?.currentStatus === 'REJECT') ? '#3498db' :
                         (items?.currentStatus === 'SHORTLISTED'||!applyingJob) ? '#3498db' :
                         (items?.currentStatus === 'PREONBOARDED') ? '#3498db' :
                         (items?.currentStatus === 'OFFER WITHDRAWN') ? '#fe4052' :
                         (items?.inviteStatus === 'ACCEPTED') ? '#008000' :
                         (items?.inviteStatus === 'REJECTED') ? '#fe4052' :
                         (items?.currentStatus === 'APPLIED') ? '#008000' :
                         (items?.inviteStatus === 'INITIATED') ? '#8B5CF6' :
                         (items?.currentStatus === 'INTETEREST_SHOWN') ? '#8B5CF6' :
                         (items?.currentStatus === 'CANDIDATE BACKOUT') ? '#fe4052' :
                         (items?.currentStatus === 'OFFERED') ? '#fe4052': ''}">
                <ng-container *ngIf="items?.inviteStatus == 'INITIATED'"> Invited </ng-container>
                <ng-container *ngIf="items?.inviteStatus === 'INTETEREST_SHOWN'"> Invited </ng-container>
                <ng-container *ngIf="items?.inviteStatus === 'REJECTED'"> Rejected </ng-container>
                <ng-container *ngIf="items?.inviteStatus != 'INITIATED'">{{items?.currentStatus|titlecase}}</ng-container>
              </span>

              <!-- Poster: the pill opens the status menu — same toggles, menu rules and
                   enableJob() calls as the 'large' owner status dropdown. Not in Member View. -->
              <div id="jb_dpDown_bizrow" [ngClass]="{'disabled':items?.status=='BLOCKED'}" class="btn-group" dropdown
                *ngIf="items?.jobPostedBy==userId && !memberPreview">
                <button type="button"
                  *ngIf="items?.status!='DRAFTED'&& items?.status!='AWAITING HOST'&& items?.status!='BLOCKED' && items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& applyingJob==false"
                  dropdownToggle class="bjr-pill bjr-pill--toggle" [ngClass]="bjrStatusClass(items?.status)" aria-expanded="true">
                  {{items?.status|titlecase}} <ng-icon name="tablerChevronDown" aria-hidden="true"></ng-icon>
                </button>
                <button type="button" *ngIf="items?.status=='BLOCKED'&& applyingJob==false"
                  dropdownToggle class="bjr-pill bjr-pill--toggle bjr-pill--active" aria-expanded="true">Active
                  <ng-icon name="tablerChevronDown" aria-hidden="true"></ng-icon></button>
                <ng-container
                  *ngIf="items?.status!='DRAFTED' &&  items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& items?.status!='DEACTIVATED' && items?.status!='BLOCKED'&&items?.status!='FILLED'&&items?.status!='AWAITING HOST'">
                  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right job-status-menu" role="menu"
                    style="right: 0;">
                    <li id="job_status_active_bizrow_menu" role="menuitem" *ngIf="items?.status!='ACTIVE'"
                      (click)="enableJob('ACTIVE',items)">
                      <a id="ACTIVE"><ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>Active </a>
                    </li>
                    <li id="job_status_onhold_bizrow_menu" role="menuitem" *ngIf="items?.status!='ON HOLD' "
                      (click)="enableJob('ON HOLD',items)">
                      <a id="ON HOLD"><ng-icon name="tablerCircle" class="fs-status-icon t-hold" aria-hidden="true"></ng-icon>On Hold </a>
                    </li>
                    <li id="job_status_filled_bizrow_menu" role="menuitem" *ngIf="items?.status!='FILLED'"
                      (click)="enableJob('FILLED',items)">
                      <a id="FILLED"><ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>Filled </a>
                    </li>
                  </ul>
                </ng-container>
              </div>

              <!-- Non-owner (and the poster in Member View): plain pill, the 'large'
                   non-owner rule (that toggle never had a menu) -->
              <span *ngIf="(items?.jobPostedBy!=userId || memberPreview) && items?.status!='DRAFTED' && items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& applyingJob==false && items?.status=='ACTIVE'"
                class="bjr-pill" [ngClass]="bjrStatusClass(items?.status)">{{items?.status|titlecase}}</span>

              <ng-template #bjrStatusShow>
                <span *ngIf="applyingJob && items?.inviteStatus==null&& items?.currentStatus!='APPLIED'"
                  class="bjr-pill bjr-pill--active">Active</span>
                <span *ngIf="items?.status=='DRAFTED'" class="bjr-pill bjr-pill--draft">Draft</span>
              </ng-template>
            </div>

            <!-- Actions -->
            <div class="bjr-acts">
              <button id="job_edit_action_bizrow" type="button" class="bjr-btn"
                *ngIf="items?.jobPostedBy==userId && !applyingJob &&items?.status!='FILLED' && !memberPreview"
                [ngClass]="{'disabled':items?.status=='BLOCKED'}" (click)="editJob(items)">Edit</button>
              <button id="job_apply_button_bizrow" type="button" class="bjr-btn bjr-btn--purple" title="Apply"
                [ngClass]="{'disabled': items?.status!='ACTIVE' || applyingJob==true || items?.status=='BLOCKED'}"
                *ngIf=" items?.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER' || userType == 'student' || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
                (click)="apply(items, connectionTemplate, candidateSupplyTemplate)">Apply</button>
              <button id="job_view_action_bizrow" type="button" class="bjr-btn"
                [ngClass]="{'bjr-btn--purple': items?.jobPostedBy==userId && !memberPreview}"
                (click)="open(items);routeBusiness(items)">View</button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="viewSize === 'small'">
        <div class="hpanel">
          <div id="jobBody" #jobBodyeee class="panel-body border-radius-top-left-right-6" [ngClass]="{
                          'disabled': !items?.availability,
                          'pad-0': viewSize == 'small',
                          'featured-background': items?.isFeatured==true,
                          'UpdatedJobHighLight' : jobIdHighLight==items?.jobId,
                          'highLightList' : selectedItem == items?.jobId  }">

            <ng-container>
              <div class="profile-card pad-10-10-10-10">
                <div class="bottom-section row">
                  <div class="col-sm-2" style="margin-top:5px;">
                    <div class="top-section">
                      <div *ngIf="items?.user?.photo!=undefined" class="user-img">
                        <img *ngIf="items?.user?.photo" [src]="getPhotoUrl(items?.user?.photo)" alt="profile-picture">
                      </div>
                      <div *ngIf="!items?.user?.photo">
                        <div class="circles mr-rt-10" [style.background-color]="getColor(items?.user?.fullname)">
                          <div class="circle-text" [style.color]="getFullNameTextColor(items?.user?.fullname)">{{
                            getInitials(items?.user?.fullname) }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="xs-btn-container">
                      <div *ngIf="items?.connectionStatus == 'CONNECTED'">
                        <ng-icon name="tablerLink" class="link primary-color" title="You are connected with this owner"></ng-icon>
                      </div>
                      <div
                        *ngIf="items?.connectionStatus == 'NOT_CONNECTED'||items?.connectionStatus == 'REJECTED' || items?.connectionStatus == 'CANCELLED'">
                        <button id="job_connect_small" class="btn btn-xs btn-primary pad-0-3" (click)="connect(items) ">
                          Connect
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="job_route_content_small" class="col-sm-10 pad-lt-18 job-route-content "
                    (click)="open(items)">
                    <div class="user-info-job">
                      <div class="user-name" title="{{items?.user?.fullname}}">
                        {{ (items?.user?.fullname?.length > 10) ? (items?.user?.fullname | slice:0:15) + ".." :
                        (items?.user?.fullname)}}
                      </div>
                      <ng-container
                        *ngIf="items?.jobPostedBehalfOf&&items?.jobPostedBehalfOf!='null'&&items?.jobPostedBehalfOf!='undefined'">
                        <span style="color: rgb(0 0 0)">&#64;</span>
                        <div class="current-org" title="{{ items.jobPostedBehalfOf }}">
                          {{ items.jobPostedBehalfOf }}
                        </div>
                      </ng-container>
                      <!-- <div class="xs-btn-container" title="From Ceipal" *ngIf="items.source == 'CEIPAL'" style="margin-right:5px; margin-left: auto;">
                        <img src="assets/images/ceipal1.png" alt="ceipal" style="height: 25px; width: auto; border-radius: 50%;" />
                      </div> -->
                    </div>


                    <div class="user-info-job">
                      <ng-icon name="tablerClock" style="margin-right: 3px;margin-top: 2px;"></ng-icon>
                      <small class="time-stamp"> {{ items?.createdOn | timezoneDate:'MM/dd/yyyy' }}</small>
                    </div>
                    <div class="job-title" title="{{items?.jobTitle}}">{{items?.jobTitle}}</div>

                    <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(items) as urgencyDays">
                      <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Urgent Hire</span>
                      <span class="urgent-hire-countdown">Urgency ends in {{urgencyDays}} day{{urgencyDays === 1 ? '' : 's'}}</span>
                    </div>

                    <div class="client-location"
                      title="{{ gigsumoService.formatLocation(items?.city, items?.state, items?.country) }}">
                      <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                      {{ gigsumoService.formatLocation(items?.city, items?.state, items?.country) }}
                    </div>

                    <div class="details">
                      <div *ngIf="items?.showClientType" title="{{items?.clientType}}" class="client-name">

                        <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                        {{items?.clientType | truncate:20}}
                      </div>
                      <div *ngIf="items?.showClientName" title="{{items?.clientName}}" class="client-name">

                        <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                        {{items?.clientName | truncate:20}}
                      </div>
                      <div title="{{items?.jobClassification}}" class="client-type">
                        <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                        {{items?.jobClassification}}
                      </div>
                      <div class="job-relocation" *ngIf="items?.workMode=='Remote'">
                        <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                        Remote
                      </div>

                      <div [title]="(items?.targetRateFrom && items?.targetRateTo) ?
                                ('Employer Estimate: ' + items?.targetRateFrom + ' - ' + items?.targetRateTo + ' ' + getJobCurrency(items) + ' / ' + getPayType(items?.payType)) :
                                'Employer Estimate: Not available'" class="job-pay">
                        Employer Estimate:
                        <ng-container *ngIf="items?.targetRateFrom && items?.targetRateTo; else noRateV2Medium">
                          <span>{{items?.targetRateFrom}} - {{items?.targetRateTo}}</span>
                          <span>{{getJobCurrency(items)}} / {{getPayType(items?.payType)}}</span>
                        </ng-container>
                        <ng-template #noRateV2Medium><span>Not available</span></ng-template>
                      </div>

                    </div>
                  </div>
                  <div class="job-section">
                    <div joyrideStep="step.joblist" *ngIf="passValues[0]" [title]="getTourData('step.joblist','title')"
                      [text]="getTourData('step.joblist','text')" joyrideStepPosition="right" target="thiru"></div>


                    <div class="user-action" #thiru>
                      <div [ngClass]="{'disabled':items?.status=='BLOCKED'}" class="btn-group"
                        *ngIf="items?.jobPostedBy==userId && items?.status!='FILLED'" dropdown>
                        <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer"></ng-icon>
                        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu upgrade-t" role="menu"
                          aria-labelledby="button-animated">
                          <li role="menuitem" *ngIf=" items?.jobPostedBy==userId ">
                            <a id="job_edit_action_small" (click)="editJob(items)">
                              <ng-icon name="tablerEdit" aria-hidden="true"></ng-icon> Edit
                            </a>
                          </li>
                          <li id="job_upgrade_action_small" (click)="featurejobvalues(items)" role="menuitem"
                            *ngIf=" items?.jobPostedBy==userId  && items?.status!='INACTIVE'  && items?.status!='DRAFTED' &&items?.status!='ON HOLD'&&items?.status!='FILLED'&& items?.isFeature=='null'    && userType !='JOB_SEEKER'  ||   !items?.isFeatured  && items?.status!='INACTIVE' && items?.status!='DRAFTED' &&items?.status!='ON HOLD'&&items?.status!='FILLED'   && items?.jobPostedBy==userId  && userType !='JOB_SEEKER' ">
                            <a>
                              <ng-icon name="tablerCircleArrowUp" aria-hidden="true"></ng-icon> Upgrade Job
                            </a>
                          </li>
                          <li id="job_downgrade_action_small" (click)="downgradeJob(items)" role="menuitem"
                            *ngIf=" items?.jobPostedBy==userId && items?.isFeatured && items?.status!='INACTIVE' && items?.status!='INACTIVE_DUE_TO_LOW_CREDITS' && items?.status!='DRAFTED' && items?.status!='DEACTIVATED'">
                            <a><ng-icon name="tablerCircleArrowDown" aria-hidden="true"></ng-icon> Downgrade job</a>
                          </li>
                          <li id="job_republish_action_small" (click)="republishJob(items)" role="menuitem"
                            *ngIf="items?.jobPostedBy==userId && items?.status=='ACTIVE'">
                            <a><ng-icon name="tablerRefresh" aria-hidden="true"></ng-icon> Republish</a>
                          </li>
                          <li id="job_discard_draft_small" (click)="deletedraft(items?.jobId)" role="menuitem"
                            *ngIf=" items?.jobPostedBy==userId  && items?.status=='DRAFTED'">
                            <a><ng-icon name="tablerTrash" aria-hidden="true"></ng-icon> Discard</a>
                          </li>
                        </ul>
                      </div>
                      <!-- Non-owner kebab, report-only - see the note on the large
                           card's kebab above. -->
                      <div class="btn-group pull-right" *ngIf="reportEnabled && items?.jobPostedBy!=userId" dropdown>
                        <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer"></ng-icon>
                        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu upgrade-t" role="menu"
                          aria-labelledby="button-animated">
                          <li role="menuitem" class="report" *ngIf="reportEnabled"
                            style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                            <app-flag type="JOB" [id]="items?.jobId" [flagTo]="items?.jobPostedBy"
                              [flags]="['Report Job as fake.']">
                            </app-flag>
                          </li>
                          <!-- <li role="menuitem">
                                                                  <a (click)="open(items)">
                                                                    View
                                                                  </a>
                                                                </li> -->
                          <li id="job_upgrade_non_owner_small" (click)="featurejobvalues(items)" role="menuitem"
                            *ngIf=" items?.jobPostedBy==userId && items?.isFeature=='null'  &&  userType !='student' && userType !='JOB_SEEKER'  ||   !items?.isFeatured && items?.jobPostedBy==userId &&  userType !='student' && userType !='JOB_SEEKER' ">
                            <a>
                              Upgrade Job
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div>
                        <div id="jb_dpDown" [ngClass]="{'disabled':items?.status=='BLOCKED'}" dropdown
                          *ngIf="items?.jobPostedBy==userId ">
                          <div *ngIf="items?.status!='DRAFTED'" data-toggle="dropdown" dropdownToggle
                            [class.pntr]="items?.status!='FILLED'&&items?.status!='CLOSED'" class="br-pd-1"
                            aria-expanded="true" [ngClass]="{'active-label': (items?.status === 'ACTIVE'),
                            'inactive-label':(items?.status === 'INACTIVE'),
                            'onhold-label':(items?.status === 'ON HOLD'),
                            'closed-label':(items?.status === 'CLOSED'),
                            'filled-label':(items?.status === 'FILLED'),
                            'blocked-label':(items?.status === 'BLOCKED'),
                            'draft-label':(items?.status === 'AWAITING HOST'),
                            'low-credit-label':(items?.status === 'INACTIVE_DUE_TO_LOW_CREDITS')}">
                            {{items?.status|titlecase}} <ng-icon name="tablerChevronDown" *ngIf="items?.status!='FILLED'&&items?.status!='CLOSED'"
                               aria-hidden="true"></ng-icon>
                          </div>
                          <div
                            *ngIf="items?.status!='DRAFTED' &&  items?.status=='INACTIVE_DUE_TO_LOW_CREDITS'&& applyingJob==false"
                            data-toggle="dropdown" dropdownToggle class="btn sm-listing-btn dropdown-toggle"
                            aria-expanded="true">
                            Deactivated
                            <ng-icon name="tablerChevronDown" aria-hidden="true"></ng-icon>
                          </div>
                          <div *ngIf="items?.status=='DRAFTED'" type="button" class="br-pd-1 draft-label">Draft</div>
                          <ng-container
                            *ngIf="items?.status!='DRAFTED' &&  items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& items?.status!='DEACTIVATED' && items?.status!='BLOCKED'&&items?.status!='FILLED'&&items?.status!='CLOSED'&&items?.status!='AWAITING HOST'">
                            <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                              role="menu" style="right:0" aria-labelledby="button-animated">
                              <li role="menuitem" *ngIf="items?.status!='ACTIVE'" (click)="enableJob('ACTIVE',items)"
                                id="job_status_active_small">
                                <a id="ACTIVE"><ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>&nbsp;Active
                                </a>
                              </li>
                              <!-- <li role="menuitem" *ngIf="items?.status!='INACTIVE'  "
                                (click)="enableJob('INACTIVE',items)" id="INACTIVE">
                                <a id="INACTIVE"><ng-icon name="tablerCircle" class="fs-status-icon t-inActive" aria-hidden="true"></ng-icon>&nbsp;Inactive </a>
                              </li> -->
                              <li role="menuitem" *ngIf="items?.status!='ON HOLD' " (click)="enableJob('ON HOLD',items)"
                                id="job_status_onhold_small">
                                <a id="ON HOLD"><ng-icon name="tablerCircle" class="fs-status-icon t-hold" aria-hidden="true"></ng-icon>&nbsp;On
                                  Hold </a>
                              </li>
                              <li id="job_status_filled_small" role="menuitem" *ngIf="items?.status!='FILLED'"
                                (click)="confirmStatusChange('FILLED',items)">
                                <a id="FILL"> <ng-icon name="tablerCircle" class="fs-status-icon t-filled" aria-hidden="true"></ng-icon>&nbsp;Filled
                                </a>
                              </li>
                              <!-- <li role="menuitem" *ngIf="items?.status!='CLOSED' " (click)="enableJob('CLOSED',items)"
                                id="CLOSED">
                                <a id="CLOSED"> <ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon>&nbsp;Closed
                                </a>
                              </li>
                              <li class="disabled" role="menuitem" id="Deactivated">
                                <a id="Deactivated"> <ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon>
                                  Deactivated </a>
                              </li> -->
                            </ul>
                          </ng-container>
                        </div>
                        <div id="jb_dpDown" class="btn-group" dropdown *ngIf="items?.jobPostedBy!=userId "> <button
                            *ngIf="items?.status!='DRAFTED' && items?.status!='INACTIVE_DUE_TO_LOW_CREDITS'&& applyingJob==false; else statusShow"
                            data-toggle="dropdown" dropdownToggle class="br-pd-1" aria-expanded="true"
                            [ngClass]="{'active-label': (items?.status === 'ACTIVE' && items?.jobPostedBy==userId),
                            'active-non-owner-label': (items?.status === 'ACTIVE' && items?.jobPostedBy!=userId),
                                                                  'inactive-label':(items?.status === 'INACTIVE'),
                                                                  'onhold-label':(items?.status === 'ON HOLD'),
                                                                  'filled-label':(items?.status === 'FILLED'),
                                                                  'deactivated-label':(items?.status === 'DEACTIVATED'),
                                                                  'awaiting-status-label':(items?.status === 'AWAITING HOST'),
                                                                  'low-credit-label':(items?.status === 'INACTIVE_DUE_TO_LOW_CREDITS')}">
                            {{items?.status|titlecase}}
                          </button>
                        </div>
                        <ng-template #statusShow>
                          <button *ngIf="applyingJob && items?.inviteStatus==null&& items?.currentStatus!='APPLIED'"
                            type="button" class="active-label br-pd-1">Active</button>
                          <button *ngIf="items?.status=='DRAFTED'" type="button"
                            class="draft-label br-pd-1">Draft</button>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="interaction-section" [ngClass]="{'disabled':items?.status=='BLOCKED'|| isJobOwner(items)}">
                <div class="interaction-element" *ngIf="items?.jobPostedBy!=userId && items?.viewedByCount > 0"
                  title="{{items?.viewedByCount}} Views" style="cursor: context-menu;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color">{{ items?.viewedByCount | compactCount }}</span>
                  Views
                </div>
                <div *ngIf="items?.jobPostedBy!=userId && items?.viewedByCount == 0" title="0 Views"
                  class="interaction-element" style="cursor: context-menu;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color">0</span>
                  Views
                </div>
                <div id="job_views_owner_small" class="interaction-element" (click)="goTo(items, 'views')"
                  *ngIf="items?.jobPostedBy==userId && items?.viewedByCount > 0" title="{{items?.viewedByCount}} Views"
                  style="cursor: pointer;">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color">{{ items?.viewedByCount | compactCount }}</span>
                  Views
                </div>
                <div id="job_no_views_owner_small" class="interaction-element"
                  *ngIf="items?.jobPostedBy==userId && items?.viewedByCount == 0" (click)="goTo(items, 'noviews')"
                  title="0 Views">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
                  <span class="blue-color">0</span>
                  Views
                </div>
                <div id="job_like_container_small" class="interaction-element" (click)="like(items)">
                  <div [ngClass]="{'disabled': items?.status!='ACTIVE'}" title="Like"
                    *ngIf="items?.isLiked!=null && !items?.isLiked">
                    <ng-icon name="tablerHeart" class="pointer icon-prime-color"></ng-icon>
                  </div>
                  <div [ngClass]="{'disabled': items?.status!='ACTIVE'}" title="Unlike"
                    *ngIf="items?.isLiked!=null &&  items?.isLiked">
                    <ng-icon name="tablerHeart" class="liked pointer bg-heart"></ng-icon>
                  </div>
                </div>
                <div id="job_likes_owner_small" class="interaction-element" title="{{items?.likesCount}} Likes"
                  (click)="goTo(items, 'jobs-liked')" *ngIf="items?.jobPostedBy==userId">
                  <span class="blue-color" *ngIf="items?.likesCount>0">{{ items?.likesCount | compactCount }}</span>
                  <span *ngIf="items?.likesCount>0"> Like<span *ngIf="items?.likesCount>1">s
                    </span> </span>
                  <div title="0 Likes" class="no-views" *ngIf="items?.jobPostedBy==userId && items?.likesCount == 0"
                    style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like
                  </div>
                </div>
                <div class="interaction-element" title="{{items?.likesCount}} Likes" *ngIf="items?.jobPostedBy!=userId"
                  style="cursor: context-menu!important;">
                  <span class="blue-color" *ngIf="items?.likesCount>0">{{ items?.likesCount | compactCount }}</span>
                  <span *ngIf="items?.likesCount>0"> Like<span *ngIf="items?.likesCount>1">s </span> </span>
                  <div title="0 Likes" class="no-views" *ngIf="items?.jobPostedBy!=userId && items?.likesCount == 0"
                    style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like
                  </div>
                </div>
                <div id="job_applied_owner_small" class="interaction-element" (click)="goTo(items,'jobs-applied')"
                  *ngIf="items?.jobPostedBy==userId">
                  <ng-icon name="tablerUsers"></ng-icon>
                  <span title="{{items?.appliedCount}} Applicants" class="blue-color"
                    *ngIf="items?.appliedCount>0">{{ items?.appliedCount | compactCount }}</span>
                  <span title="0 Applicants" class="blue-color" *ngIf="items?.appliedCount==0"> 0</span>
                  Applicants
                </div>
                <div id="job_applied_non_owner_small" class="interaction-element"
                  (click)="goTo(items,'candidate-applied')" *ngIf="items?.jobPostedBy!=userId">
                  <ng-icon name="tablerUsers"></ng-icon>
                  <span title="{{items?.appliedCount}} Applicants" class="blue-color"
                    *ngIf="items?.appliedCount>0">{{ items?.appliedCount | compactCount }}</span>
                  <span title="0 Applicants" class="blue-color"
                    *ngIf="items?.appliedCount==0 ||items?.appliedCount==null"> 0
                  </span>
                  Applicants
                </div>
                <div id="job_invites_small" class="interaction-element" title="Invites Received Count"
                  (click)="goTo(items,'candidates-invited')" *ngIf="items?.jobPostedBy==userId">
                  <ng-icon name="tablerUsers" class="pointer icon-prime-color" style="padding-right: 4px;"></ng-icon>
                  <span title="{{items?.interestShownCount}} Invites" class="blue-color"
                    *ngIf="items?.interestShownCount>0">{{ items?.interestShownCount | compactCount }}</span>
                  <span title="0 Invites" class="blue-color" *ngIf="items?.interestShownCount==0"> 0</span>
                  Invites
                </div>
                <div id="job_apply_small" class="interaction-element"
                  (click)="apply(items, connectionTemplate, candidateSupplyTemplate)"
                  [ngClass]="{'disabled': items?.status!='ACTIVE'}"
                  *ngIf=" items?.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER'
                                                  || userType == 'student' || userType == 'JOB_SEEKER'
                                                  || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
                  <ng-icon name="tablerSend"></ng-icon>
                  <div title="Apply">
                    Apply
                  </div>
                </div>
                <!-- style="cursor: context-menu;" -->
                <div id="job_chat_with_messages_small" class="interaction-element" *ngIf=" items?.chatHistoryCount > 0"
                  title="{{items?.nonSeenMessageCount}} Messages"
                  (click)="openMessagecheckInteraction(items, connectionTemplate)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  <span class="blue-color" *ngIf="items?.nonSeenMessageCount>0">{{items?.nonSeenMessageCount}}</span>
                  Chat
                </div>
                <!-- style="cursor: context-menu;" -->
                <div id="job_chat_no_messages_non_owner_small" class="interaction-element"
                  *ngIf="items?.jobPostedBy!=userId && items?.chatHistoryCount == 0"
                  (click)="openMessagecheckInteraction(items, connectionTemplate)" title="No Messages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>
                <!-- style="cursor: context-menu;" -->
                <div id="job_chat_no_messages_owner_small" class="interaction-element"
                  *ngIf="items?.jobPostedBy==userId && items?.chatHistoryCount == 0" title="No Messages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- ════════════════════════════════════════════════════════════════
           V3 DESIGN — Left Panel Job Card (jc-v3-small)
           ════════════════════════════════════════════════════════════════ -->
      <ng-container *ngIf="viewSize === 'jc-v3-small'">
        <!-- Disabled gate matches baseline V2 `small` (job.component.html:454
             in baseline): greys out the card only when the slot itself is
             unavailable. Non-owners viewing non-ACTIVE jobs still see the
             card clickable — consistent with the V2 row-design and small
             card semantics. Individual actions (Apply, Like, status pill)
             gate themselves separately on `status === 'ACTIVE'`. -->
        <div class="jc-v3-job-card" [class.active]="selectedItem == items?.jobId"
             [class.disabled]="!items?.availability"
             [class.featured-background]="items?.isFeatured == true"
             (click)="open(items)">

          <!-- Row 1: Recruiter avatar + name + date + kebab -->
          <div class="jc-v3-jc-row1">
            <img *ngIf="items?.user?.photo" class="jc-v3-jc-av"
              [src]="getPhotoUrl(items?.user?.photo)" alt="avatar"
              (error)="$any($event.target).style.display='none'">
            <div *ngIf="!items?.user?.photo" class="jc-v3-jc-av"
              [style.background-color]="getColor(items?.user?.fullname)"
              [style.color]="getFullNameTextColor(items?.user?.fullname)">
              {{ getInitials(items?.user?.fullname) }}
            </div>
            <div class="jc-v3-jc-meta">
              <!-- Recruiter name + @org. Baseline V2 wraps the
                   "behalf of" org in its own element with a distinct
                   `title` tooltip so hovering the org name shows the
                   full org even when the recruiter's full name is
                   already shown in the name tooltip
                   (job.component.html:496-501). -->
              <span class="jc-v3-jc-rec-name" [title]="items?.user?.fullname">
                {{ items?.user?.fullname }}
                <ng-container *ngIf="items?.jobPostedBehalfOf && items?.jobPostedBehalfOf != 'null' && items?.jobPostedBehalfOf != 'undefined'">
                  &#64;<span class="jc-v3-jc-org" [title]="items?.jobPostedBehalfOf">{{ items?.jobPostedBehalfOf }}</span>
                </ng-container>
              </span>
              <span class="jc-v3-jc-date">{{ items?.updatedOn | timezoneDate:'MM/dd/yyyy' }}</span>
            </div>
            <!-- Owner kebab: disabled when the job is BLOCKED, mirroring
                 V2 (job.component.html:568). Edit/Upgrade/Republish all
                 become inert — the block state takes priority over other
                 owner actions. -->
            <div class="jc-v3-jc-kebab"
                 [class.disabled]="items?.status == 'BLOCKED'"
                 *ngIf="items?.jobPostedBy==userId && items?.status!='FILLED'" (click)="$event.stopPropagation()" dropdown
                 [isOpen]="openKebabId === items?.jobId" (isOpenChange)="onKebabToggle($event, items)" dropdownToggle>
              <span>&#8942;</span>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" style="min-width:160px;">
                <li role="menuitem" *ngIf="items?.jobPostedBy==userId">
                  <a (click)="editJob(items)"><ng-icon name="tablerEdit" aria-hidden="true" style="margin-right:6px;"></ng-icon>Edit</a>
                </li>
                <li role="menuitem" *ngIf="items?.jobPostedBy==userId && !items?.isFeatured && items?.status!='INACTIVE' && items?.status!='DRAFTED' && items?.status!='ON HOLD' && items?.status!='FILLED'"
                  (click)="featurejobvalues(items)">
                  <a><ng-icon name="tablerCircleArrowUp" aria-hidden="true" style="margin-right:6px;"></ng-icon>Upgrade Job</a>
                </li>
                <!-- Downgrade exclusion list restored from V2 baseline
                     (job.component.html:586): also hides on
                     INACTIVE_DUE_TO_LOW_CREDITS and DEACTIVATED, which V3
                     had dropped. -->
                <li role="menuitem" *ngIf="items?.jobPostedBy==userId && items?.isFeatured && items?.status!='INACTIVE' && items?.status!='INACTIVE_DUE_TO_LOW_CREDITS' && items?.status!='DRAFTED' && items?.status!='DEACTIVATED'"
                  (click)="downgradeJob(items)">
                  <a><ng-icon name="tablerCircleArrowDown" aria-hidden="true" style="margin-right:6px;"></ng-icon>Downgrade Job</a>
                </li>
                <li role="menuitem" *ngIf="items?.jobPostedBy==userId && items?.status=='ACTIVE'" (click)="republishJob(items)">
                  <a><ng-icon name="tablerRefresh" aria-hidden="true" style="margin-right:6px;"></ng-icon>Republish</a>
                </li>
                <li role="menuitem" *ngIf="items?.jobPostedBy==userId && items?.status=='DRAFTED'" (click)="deletedraft(items?.jobId)">
                  <a><ng-icon name="tablerTrash" aria-hidden="true" style="margin-right:6px;"></ng-icon>Discard</a>
                </li>
              </ul>
            </div>
            <!-- Non-owner kebab, report-only - see the note on the large card's
                 kebab above. The owner's kebab (Edit / Upgrade / Downgrade /
                 Republish / Discard) is a separate block and is unaffected. -->
            <div class="jc-v3-jc-kebab" *ngIf="reportEnabled && items?.jobPostedBy!=userId" (click)="$event.stopPropagation()" dropdown
                 [isOpen]="openKebabId === items?.jobId" (isOpenChange)="onKebabToggle($event, items)" dropdownToggle>
              <span>&#8942;</span>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" style="min-width:170px;">
                <li role="menuitem" class="jc-v3-flag-item" *ngIf="reportEnabled" #flagLi
                    (click)="$event.stopPropagation(); flagLi.querySelector('app-flag p')?.click()">
                  <a>
                    <ng-icon name="tablerFlag" class="jc-v3-flag-icon" aria-hidden="true"></ng-icon>
                    Report Job
                  </a>
                  <!-- `<app-flag>` must stay in the DOM so its modal/TemplateRef
                       wiring works (the click handler above finds its inner
                       `<p>` and dispatches the click). The SCSS class
                       `.jc-v3-flag-hidden` (defined in styles/SCSS/job-center-v3.scss)
                       lifts it out of flow with `position:absolute;width:0;height:0`
                       so it occupies no visible space inside the dropdown but
                       remains queryable + clickable by JS. -->
                  <app-flag type="JOB" [id]="items?.jobId" [flagTo]="items?.jobPostedBy" [flags]="['Report Job as fake.']" class="jc-v3-flag-hidden"></app-flag>
                </li>
              </ul>
            </div>
          </div>

          <!-- Row 2: Job title + status pill.
               The status pill is a clickable dropdown for the job owner when
               the status is editable (ACTIVE / ON HOLD); otherwise a static
               pill. Mirrors V2 job.component.html pre-transformation where
               `enableJob('ACTIVE'|'ON HOLD', items)` and
               `confirmStatusChange('FILLED', items)` drove the same flow.
               `jc-v3-cand-title-row` (shared with the candidates list) pins
               the pill to the card's RIGHT edge with the title truncating —
               user asked jobs to match the candidate card's alignment. -->
          <div class="jc-v3-jc-title-row jc-v3-cand-title-row">
            <span class="jc-v3-jc-title" [title]="items?.jobTitle">{{ items?.jobTitle }}</span>

            <!-- Owner + editable status → dropdown trigger. Baseline V2
                 (job.component.html:647-686) renders the dropdown for
                 ACTIVE / ON HOLD / INACTIVE — the three statuses an owner
                 can transition out of via Active / On Hold / Filled
                 options. V3 previously only covered ACTIVE/ON HOLD, so
                 an owner whose job went INACTIVE couldn't reactivate it
                 from the card. Terminal statuses (FILLED/CLOSED/BLOCKED/
                 DRAFTED/INACTIVE_DUE_TO_LOW_CREDITS/DEACTIVATED/AWAITING
                 HOST) still render as static pills below.
                 Dropped `container="body"` — it was detaching the menu
                 from the trigger and causing offset issues. -->
            <div class="jc-v3-pill-dropdown" dropdown
                 *ngIf="items?.jobPostedBy == userId && (items?.status === 'ACTIVE' || items?.status === 'ON HOLD' || items?.status === 'INACTIVE')"
                 [isOpen]="openStatusPillId === items?.jobId"
                 (isOpenChange)="onStatusPillToggle($event, items)"
                 (click)="$event.stopPropagation()">
              <button type="button" dropdownToggle
                      class="jc-v3-pill jc-v3-pill-toggle"
                      [class.jc-v3-pill-green]="items?.status === 'ACTIVE'"
                      [class.jc-v3-pill-amber]="items?.status === 'ON HOLD'"
                      [class.jc-v3-pill-gray]="items?.status === 'INACTIVE'">
                {{ items?.status === 'ACTIVE' ? 'Active' : items?.status === 'ON HOLD' ? 'On Hold' : 'Inactive' }}
                <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="margin-left:3px;">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              <ul *dropdownMenu class="dropdown-menu jc-v3-pill-menu" role="menu">
                <li role="menuitem" *ngIf="items?.status !== 'ACTIVE'"
                    (click)="enableJob('ACTIVE', items); $event.stopPropagation()">
                  <a><span class="jc-v3-pill-dot jc-v3-pill-dot-green"></span>Active</a>
                </li>
                <li role="menuitem" *ngIf="items?.status !== 'ON HOLD'"
                    (click)="enableJob('ON HOLD', items); $event.stopPropagation()">
                  <a><span class="jc-v3-pill-dot jc-v3-pill-dot-amber"></span>On Hold</a>
                </li>
                <li role="menuitem" *ngIf="items?.status !== 'FILLED'"
                    (click)="confirmStatusChange('FILLED', items); $event.stopPropagation()">
                  <a><span class="jc-v3-pill-dot jc-v3-pill-dot-red"></span>Filled</a>
                </li>
              </ul>
            </div>

            <!-- Non-owner or terminal status → static pill. Each status
                 from baseline V2 (`active-label` / `onhold-label` /
                 `draft-label` / `filled-label` / `closed-label` /
                 `inactive-label` / `low-credit-label` /
                 `deactivated-label` / `awaiting-status-label` /
                 `blocked-label`) has a matching V3 pill. #26 splits
                 INACTIVE_DUE_TO_LOW_CREDITS out as "Deactivated"; #27
                 adds AWAITING HOST + DEACTIVATED + BLOCKED. -->
            <ng-container *ngIf="!(items?.jobPostedBy == userId && (items?.status === 'ACTIVE' || items?.status === 'ON HOLD' || items?.status === 'INACTIVE'))">
              <span class="jc-v3-pill jc-v3-pill-green" *ngIf="items?.status === 'ACTIVE'">Active</span>
              <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="items?.status === 'ON HOLD'">On Hold</span>
              <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="items?.status === 'DRAFTED'">Draft</span>
              <span class="jc-v3-pill jc-v3-pill-red" *ngIf="items?.status === 'FILLED'">Filled</span>
              <span class="jc-v3-pill jc-v3-pill-red" *ngIf="items?.status === 'CLOSED'">Closed</span>
              <span class="jc-v3-pill jc-v3-pill-gray" *ngIf="items?.status === 'INACTIVE'">Inactive</span>
              <span class="jc-v3-pill jc-v3-pill-gray" *ngIf="items?.status === 'INACTIVE_DUE_TO_LOW_CREDITS'" title="Deactivated due to low credits">Deactivated</span>
              <span class="jc-v3-pill jc-v3-pill-gray" *ngIf="items?.status === 'DEACTIVATED'">Deactivated</span>
              <span class="jc-v3-pill jc-v3-pill-amber" *ngIf="items?.status === 'AWAITING HOST'">Awaiting Host</span>
              <span class="jc-v3-pill jc-v3-pill-red" *ngIf="items?.status === 'BLOCKED'">Blocked</span>
            </ng-container>

            <!-- Featured pill removed per user request (2026-07-14) — the
                 featured-background card tint still marks upgraded jobs. -->
          </div>

          <!-- Rows 3-5: Detail rows -->
          <div class="jc-v3-jc-details">
            <!-- Location + Urgent Hire share ONE row (the badge used to sit
                 on its own row above, leaving a gap). Location ellipsizes
                 when space is tight; the badge keeps its size at the right
                 edge. Row still renders when only one of the two exists. -->
            <div class="jc-v3-jc-detail jc-v3-jc-detail--loc-urgent"
                 *ngIf="items?.city || items?.state || items?.country || getActiveUrgencyDays(items)">
              <ng-container *ngIf="items?.city || items?.state || items?.country">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                <span class="jc-v3-jc-loc-txt"
                      [title]="gigsumoService.formatLocation(items?.city, items?.state, items?.country)">
                  {{ gigsumoService.formatLocation(items?.city, items?.state, items?.country) }}
                </span>
              </ng-container>
              <div class="jc-v3-urgent-badge-compact jc-v3-urgent-badge-compact--right" *ngIf="getActiveUrgencyDays(items) as urgencyDays"
                   [title]="'Urgency ends in ' + urgencyDays + ' day' + (urgencyDays === 1 ? '' : 's')">
                <ng-icon name="tablerFlame"></ng-icon>
                Urgent Hire
              </div>
            </div>
            <div class="jc-v3-jc-detail" *ngIf="items?.jobClassification">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
              {{ items?.jobClassification }}
              <ng-container *ngIf="items?.workMode === 'Remote'"> &middot; Remote</ng-container>
            </div>
            <div class="jc-v3-jc-detail">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              <ng-container *ngIf="items?.targetRateFrom && items?.targetRateTo; else noRateV3Card">
                {{ items?.targetRateFrom }} – {{ items?.targetRateTo }} {{ getJobCurrency(items) }} / {{ getPayType(items?.payType) }}
              </ng-container>
              <ng-template #noRateV3Card>Not available</ng-template>
            </div>
          </div>

          <!-- Footer: views, likes, applicants + Apply button -->
          <div class="jc-v3-jc-footer">
            <!-- Views click: owners navigate to the views tab
                 ('views' when >0, 'noviews' when 0 — matches V2 at
                 job.component.html:726-739). Non-owners see display-only;
                 no navigation, context-menu cursor. -->
            <div class="jc-v3-jc-stat" [title]="(items?.viewedByCount || 0) + ' Views'"
              [style.cursor]="items?.jobPostedBy == userId ? 'pointer' : 'context-menu'"
              (click)="$event.stopPropagation(); items?.jobPostedBy == userId && goTo(items, (items?.viewedByCount || 0) > 0 ? 'views' : 'noviews')">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              {{ items?.viewedByCount | compactCount }}
            </div>
            <!-- Likes stat — baseline split this into two elements:
                 (a) heart toggle, disabled when !ACTIVE, calls like() always
                 (b) count → owner clickable to 'jobs-liked' tab, non-owner
                     display-only. See V2 job.component.html:740-766.
                 In the merged V3 stat we route: owner always → 'jobs-liked'
                 (not disabled by status, matching baseline); non-owner → like
                 toggle, but only when status is ACTIVE. -->
            <div class="jc-v3-jc-stat" [title]="(items?.likesCount || 0) + ' Likes'"
              [style.cursor]="items?.jobPostedBy == userId || items?.status === 'ACTIVE' ? 'pointer' : 'context-menu'"
              (click)="$event.stopPropagation(); items?.jobPostedBy == userId ? goTo(items, 'jobs-liked') : (items?.status === 'ACTIVE' && like(items))">
              <svg width="10" height="10" viewBox="0 0 24 24" [attr.fill]="items?.isLiked ? '#F43F5E' : 'none'" [attr.stroke]="items?.isLiked ? '#F43F5E' : 'currentColor'" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
              {{ items?.likesCount | compactCount }}
            </div>
            <!-- Applicants click routes by ownership — mirrors V2 at
                 job.component.html:767-784 (baseline). Owner → 'jobs-applied'
                 (their own candidates tab). Non-owner → 'candidate-applied'
                 (candidate-side tab showing the job from applicant angle). -->
            <!-- Count source: subcontracted jobs and jobs the viewer posted
                 show `eligibleApplicantCount` (downstream-eligible / owner's
                 filtered count). Everyone else sees raw `appliedCount`. -->
            <div class="jc-v3-jc-stat" [title]="(((items?.subContracted === true || items?.jobPostedBy === userId) ? items?.eligibleApplicantCount : items?.appliedCount) || 0) + ' Applicants'"
              style="cursor:pointer;"
              (click)="$event.stopPropagation(); goTo(items, items?.jobPostedBy == userId ? 'jobs-applied' : 'candidate-applied')">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
              {{ ((items?.subContracted === true || items?.jobPostedBy === userId) ? items?.eligibleApplicantCount : items?.appliedCount) | compactCount }}
            </div>
            <!-- Chat — three branches mirroring V2 (job.component.html:782-801):
                 (a) chatHistoryCount > 0 → shown to everyone, clickable, opens thread
                 (b) non-owner + 0 history → shown, clickable, initiates chat
                 (c) owner + 0 history → shown but non-interactive placeholder -->
            <div class="jc-v3-jc-stat"
                 [title]="items?.nonSeenMessageCount > 0 ? (items?.nonSeenMessageCount + ' Messages') : 'No Messages'"
                 [style.cursor]="(items?.chatHistoryCount > 0 || items?.jobPostedBy != userId) ? 'pointer' : 'context-menu'"
                 (click)="$event.stopPropagation();
                          (items?.chatHistoryCount > 0 || items?.jobPostedBy != userId)
                            && openMessagecheckInteraction(items, connectionTemplate)">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              <span *ngIf="items?.nonSeenMessageCount > 0" class="jc-v3-chat-unseen">{{ items?.nonSeenMessageCount }}</span>
            </div>
            <!-- Apply button gated to the same userTypes as baseline V2
                 (job.component.html:793-803): applicant-side roles only
                 (BENCH_RECRUITER, student, JOB_SEEKER, FREELANCE_RECRUITER,
                 MANAGEMENT_TALENT_ACQUISITION). Other userTypes (e.g.
                 recruiters viewing someone else's job) don't see Apply.
                 The button is shown regardless of status and disabled via
                 [class.disabled] when the job isn't ACTIVE — matches V2. -->
            <button class="jc-v3-jc-apply-btn"
              [class.disabled]="items?.status != 'ACTIVE'"
              (click)="$event.stopPropagation(); apply(items, connectionTemplate, candidateSupplyTemplate)"
              *ngIf="items?.jobPostedBy != userId && (userType == 'BENCH_RECRUITER' || userType == 'student' || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">Apply</button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="viewSize === 'extra-small' && !loadAPIcall">


        <div class="hpanel mr-bt-0 e-small">
          <div class="panel-body pad-6-0 border-radius-top-left-right-6" [ngClass]="{
                      'disabled': !items?.availability || (items?.status != 'ACTIVE' && items?.jobPostedBy!=  userId),
                      'pad-10-10-10-10': viewSize == 'small',
                      'featured-background': items?.isFeatured==true
                     }">
            <ng-container *ngIf="!loadAPIcall">
              <div class="xs-job-entity-container">
                <div class="xs-job-select-checkbox">
                  <div class="custom-checkbox em xs-submit-checkbox-position" *ngIf="showinviteResumeView(items)">
                    <label class="checkbox-label font-bold" style="text-align: center">
                      <input #selected (change)="selectCheckbox(items?.jobId,selected)" type="checkbox"
                        value="{{items.isSelected}}" [(ngModel)]="items.isSelected" name="list_name" />
                      <span style="left:20px;" class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div *ngIf="items?.user?.photo" class="xs-job-owner-img">
                  <img *ngIf="items?.user?.photo" [src]="downloadurl+items?.user?.photo" alt="profile-picture">
                </div>
                <div *ngIf="!items?.user?.photo">
                  <div class="circles mr-rt-10" [style.background-color]="getColor(items?.user?.fullname)">
                    <div class="circle-text" [style.color]="getFullNameTextColor(items?.user?.fullname)">{{
                      getInitials(items?.user?.fullname) }}</div>
                  </div>
                </div>
                <div class="xs-job-details">
                  <h6 id="job_title_extra_small" (click)="open(items)" class="jobtitle jc-v3-cursor-default" *ngIf="!flag"  [title]="items?.jobTitle"  >
                    {{items?.jobTitle}}
                  </h6>
                  <!-- <div class="urgent-hire-badge-compact" *ngIf="getActiveUrgencyDays(items)" style="margin-bottom: 2px;">
                    <ng-icon name="tablerFlame" style="font-size: 9px;"></ng-icon> Urgent - {{getActiveUrgencyDays(items)}}d
                  </div> -->
                  <div class="mb-5 statewrap jc-v3-cursor-default" title="{{items?.city}} , {{items?.state}}">
                    <!-- <ng-icon name="tablerMapPin" *ngIf="items?.city || items?.state"></ng-icon> -->
                    <ng-icon name="tablerMapPin" class="svg-position" *ngIf="items?.city || items?.state"></ng-icon>

                    {{items?.city}}
                    <span *ngIf="items?.state">,</span> {{items?.state}}
                  </div>
                </div>
                <div class="status-label xs-job-status" style="background: #3498db; margin-left: -34px;"
                  *ngIf="(focus === 'resume' && items?.resumeRequestStatus === 'INITIATED') || (focus === 'resume' && items?.resumeRequestStatus === 'COMPLETED')">
                  <ng-container *ngIf="items?.resumeRequestStatus === 'INITIATED'">Request Sent</ng-container>
                  <ng-container *ngIf="items?.resumeRequestStatus === 'COMPLETED'">Resume Attached</ng-container>
                </div>
                <div class="xs-job-status">
                  <div class="status-label" *ngIf="focus === 'candidate'" [ngStyle]="getStatusLabelStyle(items)">
                    <ng-container>{{ getFilterValue(items) | titlecase }}</ng-container>
                  </div>
                  <ng-template #statusShow>
                    <div class="status-label"
                      *ngIf="applyingJob && items?.inviteStatus==null&& items?.currentStatus!='APPLIED'" type="button"
                      class="btn btn-primary status-action-btn dwidth">Active</div>
                    <div *ngIf="items?.status=='DRAFTED'" type="button"
                      class="btn draft-status-btn status-action-btn dwidth">Draft</div>
                  </ng-template>
                </div>
              </div>
            </ng-container>
            <app-common-skeleton *ngIf="viewSize === 'extra-small' && loadAPIcall" [countforView]="8"
              [NameOftheScreen]="'smallcard'"></app-common-skeleton>
          </div>
        </div>
      </ng-container>
    </div>
    <app-common-skeleton *ngIf="(viewSize === 'small' || viewSize === 'jc-v3-small') && loadAPIcall" [countforView]="2"
      [NameOftheScreen]="'jobcardMediumscreen'">
    </app-common-skeleton>
  </div>
  <app-common-skeleton *ngIf="viewSize === 'extra-small' && loadAPIcall" [countforView]="4"
    [NameOftheScreen]="'JobPopup'">
  </app-common-skeleton>
</div>
<ng-template #noResult>
  <div class="jc-v3-list-empty" *ngIf="viewSize === 'jc-v3-small' && jobsFoundStatus">
    <ng-icon name="tablerSearch"></ng-icon>
    <p>{{ jobsFoundStatus }}</p>
  </div>
  <div class="wert" *ngIf="viewSize !== 'jc-v3-small' && jobsFoundStatus">
    <div class="col-md-12 mg-bt-9">
      <ng-icon name="tablerSearch"></ng-icon>
      <!-- <ng-icon name="customSearchCross" *ngIf="responseReceived"></ng-icon> -->
      <!-- <ng-icon name="tablerSearch" *ngIf="!responseReceived"></ng-icon> -->
    </div>
    <div class="col-md-12 fig">{{jobsFoundStatus}} </div>
  </div>
</ng-template>

<!-- job component -->
<app-job-template (jobReload)="onJobReload($event)"></app-job-template>

<ng-template #connectionTemplate>

  <app-connection-template [page]="'job-card-1'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [values]="values" [module]="'job'"></app-connection-template>
</ng-template>

<ng-template #candidateSupplyTemplate>
  <!-- <app-new-candidate [screenName]="'job-listing'" [jobData]="jobData" [focus]="'job'"></app-new-candidate> -->
  <ng-container>
    <div class="row mr-0">
      <div class="col-sm-8 pad-lt-rt-0">
        <div class="xs-heading-flex-parent">
          <div class="xs-heading-entity">My Candidates</div>
          <div class="xs-heading-payrate">Pay Rate</div>
          <div class="xs-heading-paytype">Type</div>
        </div>
        <div class="xs-body-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
          [scrollWindow]="false" (scrolled)="onCandidateSupplyScroll()">
          <!-- Dynamic component container for CandidatesPageComponent to break circular dependency -->
          <!-- Using div with ID so we can query it from the modal's DOM after modal renders -->
          <div #candidatesPageContainer id="candidatesPageDynamicContainer"></div>
        </div>
        <div class="xs-footer-container"></div>
      </div>
      <div class="col-sm-4 pad-lt-0 pad-rt-0">
        <!-- `data-gs-cards="native"` opts this subtree out of the global
             `_section-card.scss` legacy card styling so the Job Details
             panel renders in the same clean native look as the Invite
             popup's Candidate Details panel (new-job.component.html:457). -->
        <div class="hpanel" data-gs-cards="native"
             style="margin-bottom: 0px !important;border-radius: 20px 9px 9px 20px !important;">
          <div class="hpanel-heading xs-heading-flex-entity-detail">
            <div>Job Details</div>

            <button id="job_close_candidate_supply_modal"><span class="modalai-close" aria-hidden="true"
                (click)="closeCandidateSupplyModal()">&times;</span></button>
          </div>
          <app-job-submit-skillfilter [focus]="'job'" [jobData]="jobData" [resumes]="resumeData"
            [termsChecked]="termsCheck" [formData]="rtrFormData" [dataPasstoSkillwidgets]="dataPasstoSkillwidgets"
            (emitRemoveTag)="removeUserfromTag($event)" (closeModalEvent)="closeModal($event)">
          </app-job-submit-skillfilter>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>

<ng-template #customContent>
  <div class="animation-container">
    <div>
      <img src="{{ getTourData('step.joblist','image') }}" alt="Animated Job Card" class="animated-image">
    </div>
    <div>
      <p>{{ getTourData('step.joblist','text') }}</p>

    </div>
    <div>
      <a class="referthevideo" href="{{getTourData('step.joblist','url')}}" target="_blank" class="video-link">Refer to
        the video</a>
    </div>
  </div>
</ng-template>